const SINGLES_PLUGIN = {
  PLUGIN_NAME: 'singleItem',
  PLUGIN_VALUE: { singleItemId: 'SINGLE_ITEM_ID' },
}

export default {
  SINGLES: SINGLES_PLUGIN,
}
